function naiveRound(value, decimals = 0) {
    const p = Math.pow(10, decimals);
    return Math.round(value * p) / p;
}

function longNumberFilter (value) {
    if (value >= 1000000) return `${naiveRound(value / 1000000, 2)}M`;
    else if (value >= 1000) return `${naiveRound(value / 1000, 2)}k`;
    else return naiveRound(value, 2);
}

export const LongNumber = longNumberFilter;